import { render, staticRenderFns } from "./HolidayRemaining.vue?vue&type=template&id=5d6d13f8&scoped=true"
import script from "./HolidayRemaining.vue?vue&type=script&lang=js"
export * from "./HolidayRemaining.vue?vue&type=script&lang=js"
import style0 from "./HolidayRemaining.vue?vue&type=style&index=0&id=5d6d13f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d13f8",
  null
  
)

export default component.exports